<template>
  <div class="shcl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="回访状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="待回访" :value="0" />
                <el-option label="已回访" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF" v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">{{scope.row.produnum}}</span>
                      <span style="font-weight: 500;color:#999999" v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="回访发起时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="整体满意度"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#9aaabf" v-if="scope.row.hfmark!==1">N/A</span>
                      <span style="color:#E6A23C" v-if="scope.row.hfmark===1">{{scope.row.satis}}.0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="服务态度"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#9aaabf" v-if="scope.row.hfmark!==1">N/A</span>
                      <span style="color:#E6A23C" v-if="scope.row.hfmark===1">{{scope.row.attitude}}.0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="及时处理"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#9aaabf" v-if="scope.row.hfmark!==1">N/A</span>
                      <span style="color:#E6A23C" v-if="scope.row.hfmark===1">{{scope.row.timely}}.0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="回访状态"
                    width="120"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.hfmark===0" type="warning">待回访</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.hfmark===1">已回访</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="260"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" @click.stop="view(scope.row)" icon="el-icon-search">查看处理</el-button>
                      <el-button size="mini" @click.stop="detail(scope.row)" v-if="scope.row.hfmark===1" icon="el-icon-star-off">查看评价</el-button>
                      <el-button size="mini" v-if="scope.row.hfmark===0" :disabled="true" icon="el-icon-star-off">查看评价</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="售后处理详情"
      :visible.sync="infoVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="fullscreenLoading">
        <tr>
          <th>订单号</th>
          <td>{{infoData.order.ordernum}}</td>
          <th>原正单号</th>
          <td>{{infoData.order.beforenum}}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{infoData.order.all_name}}</td>
          <th>生产车间</th>
          <td>{{infoData.order.product_factory}}</td>
        </tr>
        <tr>
          <th>客诉时间</th>
          <td colspan="3">{{infoData.order.time}}</td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="3">{{infoData.order.address}}</td>
        </tr>
        <tr>
          <th>投诉内容</th>
          <td colspan="3">{{infoData.afterSale.content}}</td>
        </tr>
        <tr>
          <th>返修单</th>
          <td colspan="3">
            <span @click="downFile(infoData.afterSale.reworkid)" class="tcf-link"><i class="el-icon-download"></i> {{infoData.afterSale.reworkname}}</span>
          </td>
        </tr>
        <tr>
          <th>判定单</th>
          <td colspan="3">
            <el-image
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[infoData.afterSale.decision_url]"
              :src="infoData.afterSale.decision_url">
            </el-image>
          </td>
        </tr>
        <tr>
          <th style="width:80px">责任部门<br>售后原因</th>
          <td colspan="3">
            <el-table
              size="mini"
              :data="infoData.deptRson"
              style="width: 100%">
              <el-table-column
                prop="deptname"
                label="责任部门"
                align="center"
                width="100"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="rsonname"
                label="售后原因"
                align="center"
                width="130"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="num"
                label="不良数量"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="remark"
                align="center"
                label="备注"
                show-overflow-tooltip>
              </el-table-column>
            </el-table>

          </td>
        </tr>
        <tr>
          <th>责任车间</th>
          <td>{{infoData.factory}}</td>
          <th>售后赔款</th>
          <td>{{infoData.afterSale.amount}}&nbsp;元</td>
        </tr>
        <tr>
          <th>售后备注</th>
          <td colspan="3">{{infoData.afterSale.remark}}</td>
        </tr>
        <tr>
          <th>处理人</th>
          <td>{{infoData.afterSale.username}}</td>
          <th>处理时间</th>
          <td>{{infoData.afterSale.opertime}}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="infoVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="售后评价详情"
      :visible.sync="detailVisible"
      width="460px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form :model="detailForm" label-position="right" label-width="90px" size="small">
        <el-form-item label="评价人" prop="opername">
          <div>{{detailForm.opername}}</div>
        </el-form-item>
        <el-form-item label="评价时间" prop="time">
          <div>{{detailForm.time}}</div>
        </el-form-item>
        <el-form-item label="整体满意度" prop="satis" style="color:#99a9bf">
          <el-rate v-model="detailForm.satis" :texts="rateTexts" disabled show-text text-color="#ff9900" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="服务态度" prop="attitude">
          <el-rate v-model="detailForm.attitude" :texts="rateTexts" disabled show-text text-color="#ff9900" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="及时处理" prop="timely">
          <el-rate v-model="detailForm.timely" :texts="rateTexts" disabled show-text text-color="#ff9900" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="反馈建议" prop="content">
          <div>{{detailForm.content}}</div>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button @click="detailVisible=false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getAfterVisitList, getAfterSalePageInfo } from '@/api/erp'
import { getFileInfo } from '@/api/pub'

export default {
  name: 'shhf',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      afterReasonOption: [],
      groupList: [],
      searchForm: {
        search: '',
        type: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      infoVisible: false,
      oldFile: [],
      oldImg: '',
      manySelect: { multiple: true },
      auditLoading: false,
      fileLoad: '',
      imgLoad: '',
      infoData: {
        rson: '',
        factory: '',
        deptRson: [],
        order: {
          ordernum: null,
          beforenum: null,
          time: null,
          all_name: null,
          address: null,
          product_factory: null
        },
        afterSale: {
          decision_url: null,
          content: null,
          reworkname: null,
          reworkid: null,
          remark: null,
          amount: null,
          opertime: null,
          username: null
        }
      },
      overLoading: false,
      popKey: '',
      detailVisible: false,
      detailForm: {
        satis: null,
        attitude: null,
        timely: null,
        content: '',
        time: '',
        opername: ''
      },
      rateTexts: ['极差 1.0', '失望 2.0', '一般 3.0', '满意 4.0', '惊喜 5.0']
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        mark: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role
      }
      getAfterVisitList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    view(row) {
      this.fullscreenLoading = true
      getAfterSalePageInfo({ afterid: row.after_id }).then(response => {
        this.infoData = response.data
        this.infoData.factory = this.infoData.afterSale.factory
        this.infoData.deptRson = this.infoData.afterSale.reasonList
        this.fullscreenLoading = false
      }).catch(() => {
        this.fullscreenLoading = false
      })
      this.popKey = new Date().getTime().toString()
      this.infoVisible = true
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        /* this.$message({
          message: '返修单已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    detail(row) {
      this.detailForm.satis = row.satis
      this.detailForm.attitude = row.attitude
      this.detailForm.timely = row.timely
      this.detailForm.content = row.visitcontent
      this.detailForm.time = row.deltime
      this.detailForm.opername = row.delname
      this.detailVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.shcl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
